import { History } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { init, RematchRootState } from '@rematch/core';
import createLoadingPlugin from '@rematch/loading';
// import createHistory from 'history/createBrowserHistory';
import auth from '../models/auth';
import errors from '../models/errors';
import examApplications from '../models/examApplications';
import exams from '../models/exams';
import requests from '../models/requests';
import expert from '../models/expert';
import notifications from '../models/notifications';
import eventsState from '../models/events';
import asc from '../models/asc';
import qualifications from '../models/qualifications';
import ac from '../models/ac';
import experts from '../models/experts';
import applicants from '../models/applicants';
import expertExams from '../models/expertExams';
import expertChanges from '../models/expertChanges';
import accreditationCenters from '../models/accreditationCenters';

const createHistory = require('history').createBrowserHistory;

const models = {
    auth,
    applicants,
    errors,
    examApplications,
    exams,
    requests,
    expertExams,
    expert,
    expertChanges,
    experts,
    notifications,
    eventsState,
    asc,
    ac,
    accreditationCenters,
    qualifications,
};

export const browserHistory: History = createHistory();

export const store = init({
    models,
    plugins: [createLoadingPlugin({})],
    redux: {
        initialState: {},
        reducers: {
            router: connectRouter(browserHistory),
        },
        middlewares: [routerMiddleware(browserHistory)],
    },
});

export type Store = typeof store;
export type Dispatch = typeof store.dispatch;
export type IRootState = RematchRootState<typeof models> & LoadingPlugin;

interface LoadingPlugin {
    loading: {
        models: RematchRootState<typeof models>;
        effects: Dispatch;
    };
}


export default store;
